import React from 'react';
import { CallMade, CallReceived } from '@mui/icons-material';
import { Grid, Card, Typography } from '@mui/material';
import IntlMessages from '../../util/IntlMessages';
import * as tools from '../../util/tools';
import useStyles from './styles';
import { connect } from 'react-redux';

function RefuelingTanker(props) {
  const classes = useStyles();
  return (
    <Card className={classes.root}>
      <Grid
        container
        className={classes.gridTop}
        style={{
          backgroundColor: props.vFuelType === 'Gasoline' ? '#FBC02D' : '#D50000',
        }}
      >
        <Grid item xs={6}>
          <Typography variant="body1" className={classes.textTopRight}>
            {tools.miladiTojalali(props.dtAddAt)}
          </Typography>
        </Grid>
        <Grid item xs={6}>
          <Typography variant="body1" className={classes.textTopLeft}>
            <IntlMessages id="fuelCar" /> ( {props.vFuelCarCode} )
          </Typography>
        </Grid>
      </Grid>

      <Grid container className={classes.gridBottom}>
        <Grid item xs={8} className={classes.gridIcon}>
          {props.eIncreaseDecreaseType === 1 ? (
            <CallMade fontSize="small" className={classes.iconInc} />
          ) : (
            <CallReceived fontSize="small" className={classes.iconDec} />
          )}
          <Typography variant="body1">
            {props.vPetrolStationName + ' - ' + props.vPetrolStationCode}
          </Typography>
        </Grid>
        <Grid item xs={4}>
          <Typography variant="body1" className={classes.gridBottomText}>
            <span className={classes.literText}>{tools.numberformat(props.iVolume)}</span>
            <IntlMessages id="liter" />
            <span style={{ fontSize: 12 }}>
              (
              {props.vFuelType === 'Gasoline' ? (
                <IntlMessages id="gasoline" />
              ) : (
                <IntlMessages id="euro" />
              )}
              )
            </span>
          </Typography>
        </Grid>
      </Grid>
    </Card>
  );
}

const mapStateToProps = (state) => {
  return {
    field: state.field,
    loadingBtn: state.common.loadingBtn,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(RefuelingTanker);
